import './form-application.scss';

// Live validation for the Gravity Forms vacature-application form.
// Inputs start at opacity 0.5 (placeholder feel from Figma); on valid input
// opacity → 1 and the field gets `.is-valid`. On invalid input the field
// gets `.is-invalid`, the border turns rood, and a helper-error sentence
// appears underneath. Re-initialises after every GF AJAX re-render.

const VALIDATORS = {
	email: ( v ) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test( v ),
	tel:   ( v ) => /^[\d\s+()\-]{8,}$/.test( v.trim() ),
	url:   ( v ) => v === '' || /^https?:\/\/[^\s]+\.[^\s]+/.test( v ),
	text:  ( v ) => v.trim().length > 0,
};

const ERROR_MESSAGES = {
	email: '*Foutief e-mailadres',
	tel:   '*Foutief telefoonnummer',
	url:   '*Foutieve URL',
	text:  '*Dit veld is verplicht',
};

const fieldTypeOf = ( input ) => {
	if ( input.type === 'email' ) return 'email';
	if ( input.type === 'tel' )   return 'tel';
	if ( input.type === 'url' )   return 'url';
	return 'text';
};

const validateField = ( input ) => {
	const field = input.closest( '.gfield' );
	if ( ! field ) return;
	const type     = fieldTypeOf( input );
	const required = input.required
		|| field.classList.contains( 'gfield_contains_required' )
		|| field.classList.contains( 'gfield--required' );
	const empty    = input.value.trim() === '';
	let valid;

	if ( empty && ! required ) {
		valid = null; // neutral — optional field, leave alone
	} else {
		valid = VALIDATORS[ type ]( input.value );
	}

	field.classList.toggle( 'is-valid',   valid === true );
	field.classList.toggle( 'is-invalid', valid === false );

	let helper = field.querySelector( '.p-formApplication__helperError' );
	if ( valid === false ) {
		if ( ! helper ) {
			helper = document.createElement( 'p' );
			helper.className = 'p-formApplication__helperError';
			field.appendChild( helper );
		}
		helper.textContent = ERROR_MESSAGES[ type ];
	} else if ( helper ) {
		helper.remove();
	}
};

const debounce = ( fn, ms = 200 ) => {
	let t;
	return ( ...a ) => {
		clearTimeout( t );
		t = setTimeout( () => fn( ...a ), ms );
	};
};

// File-upload fields hide the native input (opacity 0) and GF's preview list,
// so the browser's own filename text is invisible. Show the chosen file name
// as an overlay on the upload button so there's a visible reference.
const updateFileName = ( input ) => {
	const field = input.closest( '.gfield' );
	if ( ! field ) return;
	const container = input.closest( '.ginput_container' ) || field;
	const hasFile  = input.files && input.files.length > 0;

	let display = container.querySelector( '.p-formApplication__fileName' );
	if ( hasFile ) {
		if ( ! display ) {
			display = document.createElement( 'span' );
			display.className = 'p-formApplication__fileName';
			const text = document.createElement( 'span' );
			text.className = 'p-formApplication__fileNameText';
			display.appendChild( text );
			container.appendChild( display );
		}
		const names = Array.from( input.files ).map( ( f ) => f.name );
		display.querySelector( '.p-formApplication__fileNameText' ).textContent =
			names.length > 1 ? `${ names.length } bestanden` : names[ 0 ];
	} else if ( display ) {
		display.remove();
	}

	field.classList.toggle( 'has-file', hasFile );
};

const initFileInputs = ( scope = document ) => {
	const files = scope.querySelectorAll(
		'.p-formApplication .gfield.gf-upload input[type="file"]'
	);
	files.forEach( ( input ) => {
		if ( input.dataset.fileNameBound ) return;
		input.dataset.fileNameBound = '1';
		input.addEventListener( 'change', () => updateFileName( input ) );
	} );
};

const init = ( scope = document ) => {
	const inputs = scope.querySelectorAll(
		'.p-formApplication .gform_wrapper input, .p-formApplication .gform_wrapper textarea'
	);
	inputs.forEach( ( input ) => {
		if (
			input.type === 'hidden' ||
			input.type === 'file' ||
			input.type === 'submit' ||
			input.type === 'button' ||
			input.dataset.liveValidate
		) {
			return;
		}
		input.dataset.liveValidate = '1';
		const run = debounce( () => validateField( input ), 200 );
		input.addEventListener( 'input', run );
		input.addEventListener( 'blur',  () => validateField( input ) );
	} );
	initFileInputs( scope );
};

init();
// GF re-renders the wrapper after AJAX submit / pagination — rebind.
document.addEventListener( 'gform_post_render', () => init( document ) );
